import { z } from 'zod';
import { ParameterError } from '../types/errors';
import { OrganizationMemberRole } from '../types/organizationMemberProfile';

export const validateOrganizationName = (name: string) => {
    const trimmedName = name.trim();

    if (trimmedName === '') return false;

    const pattern = /^[A-Za-z0-9 _-]+$/;
    return pattern.test(trimmedName);
};

export const getOrganizationNameSchema = () =>
    z.string().min(0).refine(validateOrganizationName, {
        message:
            'Organization name can be composed only of letters, numbers, spaces, underscores or dashes, and not be empty',
    });

export const validateOrganizationNameOrThrow = (name: string) => {
    const parsedOrganizationName = getOrganizationNameSchema().safeParse(name);

    if (!parsedOrganizationName.success) {
        const error = parsedOrganizationName.error.errors[0];
        if (error.code === 'custom') {
            throw new ParameterError(error.message);
        }
        throw new ParameterError(parsedOrganizationName.error.message);
    }
};

/**
 * this function checks if the current user can invite a new user with the given role
 * @param currentUserRole
 * @param inviteRole
 *
 */
export const canInviteNewUser = (
    currentUserRole: OrganizationMemberRole,
    inviteRole: OrganizationMemberRole,
) => {
    switch (currentUserRole) {
        case OrganizationMemberRole.ADMIN:
            return true;
        case OrganizationMemberRole.MANAGER:
            return (
                inviteRole === OrganizationMemberRole.MANAGER ||
                inviteRole === OrganizationMemberRole.MEMBER
            );
        case OrganizationMemberRole.MEMBER:
            return inviteRole === OrganizationMemberRole.MEMBER;
        // if currentUserRole is VIEWER, INTERACTIVE_VIEWER, EDITOR, DEVELOPER, return false as sortment is not handling them now.
        default:
            return false;
    }
};
